<ng-container *transloco="let t">
  <div class="content-dialog">
    <div class="closeDialog" *ngIf="data?.onlyView">
      <atm-icon [iconKey]="eIconKey.close" [enableEmitter]="true" (clickEvent)="closeDialog()"></atm-icon>
    </div>
    <div class="content">
      <div class="header">
        <atm-text-h6 fontWeight="bold">
          {{ t('termsAndConditions.termsTitle') }}
        </atm-text-h6>

        <img alt="Logo de Promsy en el encabezado" class="img" src="assets/images/branding/promsy_header.svg" />
      </div>
      <div #contentScroll class="conditions" (scroll)="onScroll()">
        <div *ngFor="let ts of t('termnsAndConditions.sections')">
          <atm-text-ui *ngIf="ts?.textUi" [fontWeight]="ts?.textUi?.fontWeight ?? eFontWight.regular">{{
            ts?.textUi?.text
          }}</atm-text-ui>
        </div>
      </div>

      <div class="divider" *ngIf="!data?.onlyView">
        <atm-divider></atm-divider>
      </div>

      <div class="footer" *ngIf="!data?.onlyView">
        <div class="info">
          <atm-text-caption>
            {{ t('termsAndConditions.footerText') }}
          </atm-text-caption>
        </div>
        <div class="actions">
          <mol-button
            class="decline"
            [size]="eButtonSizes.m"
            [spaceFilling]="true"
            [type]="eButtonTypes.tertiary"
            (submitEvent)="decline()">
            {{ t('termsAndConditions.decline') }}
          </mol-button>
          <mol-button
            class="agree"
            [disable]="!enableAccept"
            [size]="eButtonSizes.m"
            [spaceFilling]="true"
            (submitEvent)="acceptTerms()">
            {{ t('termsAndConditions.agree') }}
          </mol-button>
        </div>
      </div>
    </div>
  </div>
  <div class="content-alert {{ showAlert ? 'apear' : 'fadeOut' }}" *ngIf="completeView">
    <div class="alert  {{ showAlert ? 'inAnimation' : 'outAnimation' }}">
      <org-alert
        [description]="t('termsAndConditions.alertDescription')"
        [isShowClose]="false"
        [primaryButtonText]="t('termsAndConditions.alertReviewTerms')"
        [primaryButtonType]="'secondary'"
        [secondaryButtonText]="t('termsAndConditions.alertDecline')"
        [secondaryButtonType]="'destructive'"
        [text]="t('termsAndConditions.alert')"
        [type]="eAlertType.warning"
        (primaryButtonEvent)="confirmStay()"
        (secondaryButtonEvent)="confirmOut()"></org-alert>
    </div>
  </div>
</ng-container>
